import * as addressBookEvents from './domains/address-book'
import * as authenticationEvents from './domains/authentication'
import * as pastOrdersEvents from './domains/past-orders'
import * as payments from './domains/payments'
import * as phoneVerificationEvents from './domains/phone-verification'
import type { AnalyticsEventFactoryCollection } from '@/tools/analytics/types'

export const eventFactoryCollection = {
  ...phoneVerificationEvents,
  ...addressBookEvents,
  ...authenticationEvents,
  ...pastOrdersEvents,
  ...payments,
} satisfies AnalyticsEventFactoryCollection<'mParticle'>
